<template>
  <div class="student-tile d-flex flex-column">
    <InfoList v-if="loginInfoItems" :items="loginInfoItems" />
    <div v-else>No logins found</div>
  </div>
</template>

<script setup>
import InfoList from '@/components/classroom/sidePanel/info/InfoList.vue';
import { computed } from 'vue';
import logger from '@/scripts/logger.js';

const props = defineProps({
  participant: Object,
  logins: Object,
});

const loginInfoItems = computed(() => {
  var result;

  try {
    if (props.logins) {
      result = [];

      for (var login of props.logins) {

        if (login.authUrl) {
          result.push({
            title: `${login.platformName}`,
            label: `Login`,
            value: login.authUrl,
          });
        }
        else if (login.username) {
          result.push({
            title: `${login.platformName}`,
            label: `Username`,
            value: login.username,
          });

          result.push({
            label: `Password`,
            value: login.password,
          });
        }
      }
    }
  } catch (error) {
    logger.error(
      error,
      `Couldn't show logins for student: ${props.participant?.user_name} (Session: ${props.participant?.session_id}), props.logins = ${props.logins ? JSON.stringify(props.logins) : 'empty'}`
    );
  }

  return result;
});
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.student-tile {
  padding: 2vh;

  .empty-state {
    opacity: 0.7;
  }
}
</style>